import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';

import Sticky from 'Components/Sticky';
import SeekerBidsTable from 'Components/SeekerBidsTable';

import ActionLoader from 'Components/ActionLoader';

import { FETCH_SEEKER_BIDS, CLEAR_FETCH_SEEKER_BIDS, CLEAR_RFQ_DETAIL, UPDATE_TK11, GET_CURRENCY_DETAILS, GET_CURRENCY_TYPES } from 'Constants/actionConstants';
import { SEEKER, RFQ_DISPLAY_LIMIT } from 'Constants/commonConstants';

import { ReactComponent as OpenIcon } from 'Icons/open.svg';
import { ReactComponent as BackIcon } from 'Icons/back.svg';

import { getDashboardActiveView, getUser } from 'Utils/storage';
import classNames from 'classnames';


class TK11Dashboard extends Component {
    state = {
        selectedBids: [],
        isTimerShown: true,
        isRFQDetailsShown: false,
        remarks: "",
        instructions: "",
        acceptLoiFrom: new Date().getTime(),
        acceptLoiTo: new Date().setHours(new Date().getHours()+2),
        focusedFrom: false,
        focusedTo: false,
        approverMsg: null,
    };
    isApprovalMode = this.props.match.path === '/seeker/bids/:id/approval'
   
    loiApproverType= this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();

    seekerBidsTimer = null;
    
    toggleRFQDetails = ()=> {
        this.setState({
            isRFQDetailsShown: !this.state.isRFQDetailsShown
        })
    }
    
    setBids = (selectedBids)=> {
        this.setState({
            selectedBids
        });
    }
    getSeekerBids = (filters={})=> {
        
        let approverType=0, limits=0;
        if(this.loiApproverType===10 || this.loiApproverType===12){
            approverType=this.loiApproverType;
            limits=1000;
        }else{
            limits=RFQ_DISPLAY_LIMIT; //this.props.tripsCount ? this.props.tripsCount : 1000;
        }
        const { dispatch, match } = this.props;
        this.setState({
            filters
        })
        const user = getUser();
        dispatch({
            type: FETCH_SEEKER_BIDS,
            params: {
                rfqId: match.params.id,
                limit: limits,
                type: (approverType!==0)?approverType:undefined,
                isTk11: true, //user.isTk11,
                ...filters
            },
            onSuccess: ((data)=> {
                this.setSeekerBidsTimer();
                this.setState({
                    isTimerShown: false,
                    approverMsg: data.approver_message
                }, ()=> {
                    this.setState({
                        isTimerShown: true
                    })
                });
            }),
            onError: this.seekerBidsTimer
        })
    }
    setSeekerBidsTimer = ()=> {
        if(this.unmounted) {return};
        if(this.seekerBidsTimer) {
            clearTimeout(this.seekerBidsTimer);
        }
        this.seekerBidsTimer = setTimeout(()=> {
            this.getSeekerBids(this.state.filters);
        }, 10000);

    }
    
    componentWillUnmount() {
        this.unmounted = true;
        if(this.seekerBidsTimer) {
            clearTimeout(this.seekerBidsTimer);
        }
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_RFQ_DETAIL
        });
    }
    
    refreshSeekerBids = (filters)=> {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_FETCH_SEEKER_BIDS
        })
        this.getSeekerBids(filters);
    }

    updateTk11Details = (data) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPDATE_TK11,
            data
        });
    }
    
    componentDidMount() {
        const { dispatch } = this.props;
        
        dispatch({
            type: CLEAR_FETCH_SEEKER_BIDS
        })
        dispatch({
			type: GET_CURRENCY_DETAILS
		})
        dispatch({
            type: GET_CURRENCY_TYPES
        })
        this.getSeekerBids();
        
    }
    
    render() {
        const { 
            rfq, 
            vehicleTypes, 
            vehicleBodyTypes, 
            tripsCount, 
            trips, 
            loadingTrips, 
            challengePriceSubmitting, 
            sendLoiSubmitting, 
            uploadingBiddingDetails, 
            downloadingBiddingDetails,
            paymentCycles,
            pricingBasis,
            systemTime,
            currencyTypes
        }  = this.props;
        const dashboardActivestatus= this.props.location.state && this.props.location.state.dashboardActiveView ? this.props.location.state.dashboardActiveView : getDashboardActiveView();
        return (
            
            <div>
                {loadingTrips && <ActionLoader fixed={true}/>}

                <Sticky>  
                  <div className="pr">  
                    {rfq && <Link className="ht-30 flex flex-middle pl-40 wt-max-content mb-10 mt-5" to={"/"}>
                        <BackIcon className="mr-10 fill-theme curP"/>
                        <div className="flex flex-bottom">
                        <div className="header-dark-color fs-16 fBold">{rfq.rfqDetails.name}</div>
                        <div className="ml-5 table-text-color fRegular fs-12 op-79 lh-15p">RFQ {rfq.rfqNumber}</div>
                        </div>
                    </Link>}
                    {rfq && <div className={classNames("mr-15 ml-15 ph-20 pv-10 mb-20 br-5 pa r-10 t-0 bg-white z-1", {'box-shadow': this.state.isRFQDetailsShown})}>
                        <div className="flex flex-between flex-middle fs-22 header-dark-color fSemibold">
                            <span className="mr-10 curP flex mr-30 fs-16" onClick={this.toggleRFQDetails}>RFQ Details<span className="triangle ml-10 rotate-180"></span></span>
                            <span className="flex-1"></span>
                            
                            <Link to = {"/rfq/view/" + rfq.id + "/" + rfq.rfqDetails.serviceType + "/" + rfq.type} className="flex flex-middle">
                                <OpenIcon className="ht-15 wt-15 mr-5 curP"/>
                                <div className="pr fs-14 theme-color curP t-2">Open RFQ</div>
                            </Link>
                        </div> 
                        {this.state.isRFQDetailsShown && <div className="flex mt-20">
                            <div className="flex flex-column mr-50">
                                <div className="flex header-dark-color fSemibold fs-16 mb-10">
                                    <div className="fs-16 mr-10 wt-100">Floated</div>
                                    <div className="fs-16 wt-150">{rfq.rfqDetails.floated}</div>
                                </div>
                                <div className="flex header-dark-color fSemibold fs-16 mb-10">
                                    <div className="fs-16 mr-10 wt-100">Floated By</div>
                                    <div className="fs-16 wt-150">{rfq.rfqDetails.floatedBy}</div>
                                </div>
                                <div className="flex header-dark-color fSemibold fs-16">
                                    <div className="fs-16 mr-10 wt-100">Floated On</div>
                                    <div className="fs-16 wt-150">{Moment(rfq.created).format("DD MMM YYYY")}</div>
                                </div>
                            </div>
                            <div className="flex flex-column">
                                <div className="flex header-dark-color fSemibold fs-16 mb-10">
                                    <span className="fs-16 mr-10 wt-150">Contract Tenure</span>
                                    <span className="fs-16">{Moment(rfq.rfqDetails.contractTenureFrom).format('DD MMM YYYY') + ' - ' + Moment(rfq.rfqDetails.contractTenureTo).format('DD MMM YYYY')}</span>
                                </div>
                                <div className="flex header-dark-color fSemibold fs-16">
                                    <span className="fs-16 mr-10 wt-150">RFQ Name</span>
                                    <span className="fs-16">{rfq.rfqDetails.name}</span>
                                </div>
                            </div>
                        </div>}
                    </div>}
                    {rfq && 
                        <SeekerBidsTable 
                            rfq={rfq}
                            dashboardActiveView={dashboardActivestatus}
                            setBids={this.setBids} 
                            trips={trips}
                            fetchTrips={this.refreshSeekerBids}
                            offset={0}
                            showPagination={false}
                            vehicleTypes = {vehicleTypes}
                            vehicleBodyTypes = {vehicleBodyTypes}
                            tripsCount={tripsCount}
                            loadingTrips={loadingTrips}
                            selectedBids={this.state.selectedBids}
                            paymentCycles={paymentCycles}
                            pricingBasis={pricingBasis}
                            isApprovalMode={this.isApprovalMode}
                            postBid={this.postBid}
                            updateTk11Details={this.updateTk11Details}
                            hideTransportersName={rfq.hideTransportersName}
                            displayBaseVolume={rfq.displayBaseVolume}
                            postChallengePrice={this.postChallengePrice}
                            isTK11={true}
                            currencyTypes={currencyTypes}
                        />
                    }
                    
                  </div>
                </Sticky>
            </div>
        )
    }
}


const mapStateToProps = ({constants, rfq, contracting, common}) => {
    return {
        rfq: rfq.seekerBids.data,
        vehicleTypes: constants.vehicleTypes || [],
        vehicleBodyTypes: constants.vehicleBodyTypes || [],
        tripsCount: rfq.seekerBids.tripsCount,
        trips: rfq.seekerBids.trips,
        loadingTrips: rfq.seekerBids.dataLoading,
        challengePriceSubmitting: contracting.challengePrice.dataSubmitting,
        sendLoiSubmitting: contracting.sendLoi.dataSubmitting,
        uploadingBiddingDetails: contracting.uploadBiddingDetails.dataSubmitting,
        downloadingBiddingDetails: contracting.downloadBiddingDetails.dataSubmitting,

        paymentCycles: constants.paymentCycles || [],
        businessVolumes: constants.businessVolumes || [],
        pricingBasis: constants.pricingBasis || [],
        slabs: constants.slabs || [],
        currencyTypes: constants.currencyTypes || [],

        systemTime: common.systemTime
    }
};


export default connect(mapStateToProps)(TK11Dashboard);